import { render } from "./ReviewViewEditModal.vue?vue&type=template&id=e90637f0&scoped=true"
import script from "./ReviewViewEditModal.vue?vue&type=script&lang=js"
export * from "./ReviewViewEditModal.vue?vue&type=script&lang=js"

import "./ReviewViewEditModal.vue?vue&type=style&index=0&id=e90637f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90637f0"]])

export default __exports__